const REQUESTS_KEY = "nm_site_requests";

function createRequestId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function formatRequestDate(date = new Date()) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

function getRequests() {
  return Array.isArray(window.NMApi?.cache?.requests) ? window.NMApi.cache.requests : [];
}

function saveRequests(requests) {
  if (window.NMApi) window.NMApi.cache.requests = requests;
  return requests;
}

function addRequest(payload) {
  const request = {
    id: createRequestId(),
    date: formatRequestDate(),
    name: String(payload.name || "").trim(),
    contact: String(payload.contact || "").trim(),
    source: String(payload.source || "Форма обратной связи").trim(),
    status: "new",
    createdAt: Date.now(),
  };

  const next = [request, ...getRequests().filter((item) => item.id !== request.id)];
  saveRequests(next);

  if (window.NMApi?.addRequest) {
    return window.NMApi.addRequest(request).then((created) => {
      if (created?.id) {
        const synced = getRequests().map((item) => (item.id === request.id ? { ...item, ...created } : item));
        saveRequests(synced);
      }
      return created || request;
    });
  }
  return Promise.resolve(request);
}

function deleteRequest(id) {
  if (window.NMApi?.deleteRequest) {
    window.NMApi.deleteRequest(id).catch(() => null);
  }
  const next = getRequests().filter((item) => item.id !== id);
  saveRequests(next);
  return next;
}

function isValidEmail(value) {
  if (!value) return true;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

function getPhoneDigits(value) {
  return String(value || "").replace(/\D/g, "");
}

function normalizePhoneDigits(value) {
  let digits = getPhoneDigits(value);
  if (!digits) return "";

  if (digits.startsWith("8")) {
    digits = `7${digits.slice(1)}`;
  } else if (!digits.startsWith("7")) {
    digits = `7${digits}`;
  }

  return digits.slice(0, 11);
}

function formatPhoneInput(value) {
  const digits = normalizePhoneDigits(value);
  if (!digits) return "";
  if (digits === "7") return "+7";

  const local = digits.slice(1);
  let result = "+7";

  if (local.length > 0) {
    result += ` (${local.slice(0, 3)}`;
  }
  if (local.length > 3) {
    result += `) ${local.slice(3, 6)}`;
  }
  if (local.length > 6) {
    result += `-${local.slice(6, 8)}`;
  }
  if (local.length > 8) {
    result += `-${local.slice(8, 10)}`;
  }

  return result;
}

function isValidPhone(value) {
  return /^7\d{10}$/.test(normalizePhoneDigits(value));
}

function clearFeedbackErrors(form) {
  form.querySelectorAll("[data-feedback-field]").forEach((field) => {
    field.classList.remove("has-error");
    const error = field.querySelector("[data-feedback-error]");
    if (error) error.hidden = true;
  });
}

function showFeedbackError(form, name) {
  const field = form.querySelector(`[data-feedback-field="${name}"]`);
  if (!field) return;
  field.classList.add("has-error");
  const error = field.querySelector("[data-feedback-error]");
  if (error) error.hidden = false;
}

function handlePhoneInput(event) {
  const input = event.currentTarget;
  const fieldInput = input;
  let rawValue = fieldInput.value;
  const previousValue = fieldInput.dataset.phoneValue || "";
  const isDeleting = event.inputType === "deleteContentBackward"
    || event.inputType === "deleteContentForward";

  if (isDeleting && previousValue) {
    const previousDigits = normalizePhoneDigits(previousValue);
    const nextDigits = normalizePhoneDigits(rawValue);

    // Стирали скобку/дефис/пробел — убираем и последнюю цифру
    if (previousDigits && nextDigits.length >= previousDigits.length) {
      rawValue = previousDigits.slice(0, -1);
    }
  }

  const formatted = formatPhoneInput(rawValue);
  fieldInput.value = formatted;
  fieldInput.dataset.phoneValue = formatted;

  const field = fieldInput.closest("[data-feedback-field]");
  if (!field) return;
  field.classList.remove("has-error");
  const error = field.querySelector("[data-feedback-error]");
  if (error) error.hidden = true;
}

function handleFeedbackSubmit(event) {
  event.preventDefault();

  const form = event.currentTarget;
  const success = form.querySelector("[data-feedback-success]");
  clearFeedbackErrors(form);
  if (success) success.hidden = true;

  const formData = new FormData(form);
  const name = String(formData.get("name") || "").trim();
  const email = String(formData.get("email") || "").trim();
  const phoneRaw = String(formData.get("phone") || "").trim();
  const phone = formatPhoneInput(phoneRaw);
  const source = form.getAttribute("data-request-source") || "Форма обратной связи";

  let hasError = false;

  if (!name) {
    showFeedbackError(form, "name");
    hasError = true;
  }

  if (!isValidPhone(phoneRaw)) {
    showFeedbackError(form, "phone");
    hasError = true;
  }

  if (!isValidEmail(email)) {
    showFeedbackError(form, "email");
    hasError = true;
  }

  if (hasError) return;

  const contact = email ? `${phone} / ${email}` : phone;
  const submitBtn = form.querySelector("[type=\"submit\"]");
  if (submitBtn) submitBtn.disabled = true;

  addRequest({
    name,
    contact,
    source,
  }).then(() => {
    form.reset();
    if (success) success.hidden = false;

    if (form.closest("#popup-feedback") && typeof window.closePopup === "function") {
      window.setTimeout(() => {
        window.closePopup("popup-feedback");
        if (success) success.hidden = true;
      }, 1200);
    }
  }).catch(() => {
    showFeedbackError(form, "phone");
    if (success) success.hidden = true;
  }).finally(() => {
    if (submitBtn) submitBtn.disabled = false;
  });
}

document.querySelectorAll("[data-feedback-form]").forEach((form) => {
  form.addEventListener("submit", handleFeedbackSubmit);

  form.querySelectorAll("input").forEach((input) => {
    const fieldInput = input;

    if (fieldInput.name === "phone") {
      fieldInput.setAttribute("inputmode", "tel");
      fieldInput.setAttribute("maxlength", "18");
      fieldInput.dataset.phoneValue = fieldInput.value || "";
      fieldInput.addEventListener("input", handlePhoneInput);
      return;
    }

    fieldInput.addEventListener("input", () => {
      const field = fieldInput.closest("[data-feedback-field]");
      if (!field) return;
      field.classList.remove("has-error");
      const error = field.querySelector("[data-feedback-error]");
      if (error) error.hidden = true;
    });
  });
});

window.NMSiteRequests = {
  REQUESTS_KEY,
  getRequests,
  saveRequests,
  addRequest,
  deleteRequest,
  formatRequestDate,
  isValidPhone,
  formatPhoneInput,
};
